import { render, staticRenderFns } from "./ChooseMarket.vue?vue&type=template&id=84fe04aa"
import script from "./ChooseMarket.vue?vue&type=script&lang=js"
export * from "./ChooseMarket.vue?vue&type=script&lang=js"
import style0 from "./ChooseMarket.vue?vue&type=style&index=0&id=84fe04aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports